import styled from 'styled-components';

const DropdownInfoText = styled.div`
  color: var(--color-accent-secondary-default);
  font-size: 14px;
  margin-left: 16px;
  margin-top: 8px;
`;

const PaymentMethodInput = styled.div``;
const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: center;
`;

export { DropdownInfoText, LoadingContainer, PaymentMethodInput };
